import { render, staticRenderFns } from "./HorizontalScrollIntervalPro.vue?vue&type=template&id=8a32972a&scoped=true"
import script from "./HorizontalScrollIntervalPro.vue?vue&type=script&lang=js"
export * from "./HorizontalScrollIntervalPro.vue?vue&type=script&lang=js"
import style0 from "./HorizontalScrollIntervalPro.vue?vue&type=style&index=0&id=8a32972a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a32972a",
  null
  
)

export default component.exports